import React from 'react';
import { useNavigate } from 'react-router-dom';
import { string } from 'prop-types';

import LOGO from 'Icon/logoajaib.png';

import TopNavMenu from './TopNavMenu';

import StockTickerTabs from './StockTickerTabs';

import { styAjaibLogo, styLeftSide, styMiddleSide, styTopNav } from './style';

function TopNav({ className, style }) {
  const navigate = useNavigate();

  return (
    <div className={`${styTopNav} ${className}`} style={style}>
      <section className={styLeftSide}>
        <img
          src={LOGO}
          alt="Ajaib Logo"
          onClick={() => {
            navigate('/home/');
          }}
          className={styAjaibLogo}
        />
        <nav>
          <TopNavMenu />
        </nav>
      </section>
      <StockTickerTabs className={styMiddleSide} />
    </div>
  );
}

TopNav.defaultProps = {
  className: '',
  style: null,
};

TopNav.propTypes = {
  className: string,
  style: string,
};

export default TopNav;
